import { createFileRoute, redirect } from "@tanstack/react-router";

/** Sammanslagen med elavtalssidan – permanent omdirigering. */
export const Route = createFileRoute("/elpriser/manadspris")({
  beforeLoad: () => {
    throw redirect({ to: "/elavtal/manadspris", statusCode: 301 });
  },
});
